export const MAIN_AUTH_CONFIG = {
  tokenKey: 'dream_main_token',
  loginPath: '/login',
  protectedPath: '/dashboard',
  tokenRefreshInterval: 30000, // 30 seconds
};

export const MONITORING_AUTH_CONFIG = {
  tokenKey: 'dream_monitoring_token',
  loginPath: '/monitoring/login',
  protectedPath: '/monitoring',
  tokenRefreshInterval: 30000, // 30 seconds
};

// Legacy export for backward compatibility
export const AUTH_CONFIG = MONITORING_AUTH_CONFIG;
